module.exports = __webpack_public_path__ + "img/pig8.a325aae7.png";